import React from 'react';
import { CarouselProvider, Slider, Slide,DotGroup } from 'pure-react-carousel';
import '../css/Loader.css';
import urls from "../configs/urls";
import ls from 'local-storage'
import {withRouter} from "react-router";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/styles.css';



class CustomSlider extends React.Component {
    options = {
        items: 1,
        nav: false,
        rewind: true,
        autoplay: true,
        margin:20,
        stagePadding:30,
        loop:true
    };

    constructor(props){
        super(props);
        this.state={
            slides:props.slides
        }
    }
    componentWillReceiveProps(props) {
        this.setState(
            {slides:props.slides})
    }
    render () {
        console.log('Slides :',this.state.slides);
        if(this.state.slides.length > 0)
            return (
                <OwlCarousel options={this.options} >

                    {this.state.slides.map((slide) =>{
                        return (<div className={"sliderDiv"}><img onClick={()=>this.handleSlideClick(slide)} src={urls.SiteUrl+slide.img}/></div>)
                    })}
                    {/*<div style={{borderRadius:"10px", overflow:"hidden"}}><img src="https://asooone.ir/upload/sliderShops/1608117124.png"/></div>*/}


                    {/*<div style={{borderRadius:"10px", overflow:"hidden"}}><img src="https://asooone.ir/upload/sliderShops/1607767178.jpg"/></div>*/}
                </OwlCarousel>
                );
        else return('');
    }

    handleSlideClick = (slide)=>{
        switch (slide.type) {
            case "STORE":
                if(slide.stores_id.includes(',')){
                    ls.set('stores_id',slide.stores_id);
                    this.props.history.push("/stores_show");
                }
                else{
                    ls.set("store_id",slide.stores_id.replace("[","").replace("]",""));
                    this.props.history.push({
                        pathname: '/store',
                        state: {id:slide.stores_id.replace("[","").replace("]","")}
                    });
                }
                break;
            case "PRODUCT":
                if(slide.products_id.includes(',')){
                    ls.set('product_id',slide.products_id);
                    this.props.history.push("/products");
                }
                else{
                    ls.set("product_id",slide.products_id.slice(1, slide.products_id.length-1));
                    this.props.history.push("/product");
                }
                break;
            case "LINK":
                window.open(slide.url);
                break;
            case "sr":
                ls.set("service_id",slide.serivce_id);this.props.history.push("/service");
                break;

        }
    }
}

export default withRouter(CustomSlider);
